import Component from '@glimmer/component';

export default class MwHomeLoginPageComponent extends Component {}